<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Income</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalIncome | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Outcome</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalOutcome | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-primary">Total Outstanding</span></h5>
            <h3 class="my-3">
              <span>
                {{ totalOutstanding | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Kas Besar Piutang</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i>
                          Filter
                          <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Company:</span>
                        <div class="dropdown-divider"></div>
                        <li v-for="ct in companyList" :key="ct.id">
                          <a href="#" class="small" tabIndex="-1">
                            <input type="checkbox" :value="ct.company_no" v-model="filterCompany"/>&nbsp; {{ ct.name }}
                          </a>
                        </li>
                      </ul>
                      <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addCash">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect" @click="refreshList">
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                      </button>
                      rows:
                      <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                        <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                      </select>
                      <span class="mr-1">
                        Total rows: <b>{{ rowsTotal }}</b>
                      </span>
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">
                    page:
                    <select v-model="currentPage">
                      <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                    </select>
                    / {{ pageLength }}
                  </span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm">
                    <thead>
                        <tr>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                              {{ t.name }}
                              <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="d in filterData" :key="d.id" style="cursor: pointer">
                        <!-- <td>
                          <label class="form-checkbox">
                              <input type="checkbox" :value="d.id" v-model="selected">
                              <i class="form-icon"></i>
                            </label>
                        </td> -->
                        <td @click="editData(d.id)" >
                          <span class="badge badge-primary" v-if="d.status === 'approved'">{{ d.status }}</span>
                          <span class="badge badge-success" v-else-if="d.status === 'open'">{{ d.status }}</span>
                          <span class="badge badge-success" v-else-if="d.status === 'entry'">{{ d.status }}</span>
                          <span class="badge badge-warning" v-else>{{ d.status }}</span>
                        </td>
                        <td>{{ d.types }}</td>
                        <td @click="editData(d.id)" ><b>{{ d.cash_no }}</b></td>
                        <td @click="editData(d.id)" >{{ d.cash_date | dateFormat('DD/MM/YYYY')}}</td>
                        <td @click="editData(d.id)">{{ d.company }}</td>
                        <td @click="editData(d.id)">{{ d.employee }}</td>
                        <td @click="editData(d.id)" class="text-right">{{ d.total_outcome | currency }}</td>
                        <td @click="editData(d.id)" class="text-right">{{ d.total_income | currency }}</td>
                        <td @click="editData(d.id)" class="text-right">{{ d.total | currency }}</td>
                      </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { cohUrl, getHeader } from '../../config'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'KasPiutangList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), 0, 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      filterCompany: [],
      startDate: [date1, date2],
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Cash No',
        prop: 'cash_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'cash_date',
        align: 'text-left'
      }, {
        name: 'Company',
        prop: 'company',
        align: 'text-left'
      }, {
        name: 'Employee',
        prop: 'employee',
        align: 'text-left'
      }, {
        name: 'Total Plafon',
        prop: 'total_outcome',
        align: 'text-right'
      }, {
        name: 'Total Angsuran',
        prop: 'total_income',
        align: 'text-right'
      }, {
        name: 'Outstanding',
        prop: 'total',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
    this.$store.dispatch('getRowTable')
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    editData: function (id) {
      this.$Progress.start()
      this.loader.isLoading = true
      axios.get(cohUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editCash', response.data.data)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    addCash: function () {
      this.$emit('newCash', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = cohUrl + '?begin=' + begin + '&end=' + end + '&type=kas-besar-piutang'
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      accountSaldoAwal: state => state.accounts.accountSaldoAwal
    }),
    totalIncome () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_income)
      }
      return sum
    },
    totalOutcome () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_outcome)
      }
      return sum
    },
    totalOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  }
}
</script>
